<template>
  <v-layout row wrap justify-center>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Descricão</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">
      <span v-if="folder.subject">{{ folder.subject }}</span>
      <v-btn
          v-if="folder.folder_status.name !== 'Arquivado'"
          class="my-0 pa-0 custom-button"
          color="blue"
          flat
          icon
          small
          @click="showDialogSubjectFolder = true"
      >
        <v-icon size="16">mdi-pencil</v-icon>
      </v-btn>
    </v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Número {{ externalProtocolName }}</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">
      <span v-if="folder.number">{{ folder.number }}</span>
      <v-btn
        v-if="folder.number"
        class="my-0 pa-0 custom-button"
        color="blue"
        flat
        icon
        small
        @click="showDialog = true"
      >
        <v-icon size="16">mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        v-else
        class="pa-0 my-0 custom-button"
        small
        flat
        color="blue"
        @click="showDialog = true"
      >
        Adicionar
        <v-icon right size="16">mdi-plus</v-icon>
      </v-btn>
    </v-flex>

    <v-flex v-if="folder.confidential" xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Visibilidade</small>
    </v-flex>
    <v-flex v-if="folder.confidential" xs7 class="pl-2 my-2 process-restricted">Processo Restrito</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Última Alteração</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ formatDateTime(folder.last_modification_at) }}</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Criação</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ formatDateTime(folder.created_at) }}</v-flex>

    <v-flex xs5 class="pr-2 my-2 grey--text text-xs-right">
      <small>Status</small>
    </v-flex>
    <v-flex xs7 class="pl-2 my-2">{{ folder.folder_status.name || "" }}</v-flex>


    <v-dialog
      v-model="showDialog"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          <h4 class="headline">Informar {{ externalProtocolName }}</h4>
        </v-card-title>

        <v-form @submit.prevent="saveNumber" v-model="valid">
          <v-card-text class="no-overflow">
            <v-layout justify-center align-center>
              <!-- <strong class="grey--text text--darken-1 mr-3">4903 - </strong> -->
                <v-text-field
                  :label="`Número ${externalProtocolName}`"
                  solo
                  style="max-height: 55px"
                  v-model="number"
                  :rules="[validationRules.required]"
                />
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn type="button" flat color="black" @click="cancel('number')">Cancelar</v-btn>
            <v-btn type="submit" flat color="blue" :disabled="!valid">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showDialogSubjectFolder"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          <h4 class="headline">Alterar Descrição da Pasta</h4>
        </v-card-title>

        <v-form @submit.prevent="saveSubject" v-model="validSubject">
          <v-card-text class="no-overflow">
            <v-layout justify-center align-center>
              <!-- <strong class="grey--text text--darken-1 mr-3">4903 - </strong> -->
                <v-textarea
                  label="Descrição da Pasta"
                  maxlength="250"
                  counter
                  solo
                  no-resize
                  v-model="subject"
                  :rules="[validationRules.required]"
                />
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn type="button" flat color="black" @click="cancel('subject')">Cancelar</v-btn>
            <v-btn type="submit" flat color="blue" :disabled="!validSubject">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import { capitalize } from 'lodash';
import validationRules from '@/mixins/validation-rules';
import externalProtocolName from '@/utils/external-protocol-name';

export default {
  name: 'folder-info',
  data() {
    return {
      showDialog: false,
      showDialogSubjectFolder: false,
      number: '',
      subject: '',
      valid: false,
      validSubject: false,
      validationRules,
    };
  },
  methods: {
    formatDateTime(dateTime) {
      const date = format(dateTime, 'DD', { locale: ptLocale });
      const month = format(dateTime, 'MMMM', { locale: ptLocale });
      const year = format(dateTime, 'YYYY', { locale: ptLocale });
      return `${date} de ${capitalize(month)} de ${year}`;
    },
    saveNumber() {
      const body = {
        folder: {
          number: this.number,
        },
        id: this.folder.id,
      };
      this.$store.dispatch('addNumber', body);
      this.showDialog = false;
    },
    cancel(field) {
      this.showDialog = false;
      this.showDialogSubjectFolder = false;
      this[field] = this.folder[field];
    },
    saveSubject() {
      const body = {
        folder: {
          subject: this.subject,
        },
        id: this.folder.id,
      };
      this.$store.dispatch('updateSubject', body);
      this.showDialogSubjectFolder = false;
    },
  },
  computed: {
    folder() {
      this.number = this.$store.getters.activeFolder.number;
      this.subject = this.$store.getters.activeFolder.subject;
      return this.$store.getters.activeFolder;
    },
    externalProtocolName() {
      return externalProtocolName();
    },
  },
};
</script>

<style scopped>
  .custom-button {
    height: 21px;
    width: 21px;
  }
  .no-overflow {
    overflow: hidden;
  }
  template{
    width: 80%;
  }
  .process-restricted {
    color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/info/FolderInfo.vue